export default __webpack_public_path__ + "static/media/3.742ebf4c.png";